import { render, staticRenderFns } from "./MyCompanyWriteoffFormsNew.vue?vue&type=template&id=1d785512&"
import script from "./MyCompanyWriteoffFormsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyWriteoffFormsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports